import { SortOrder } from './sort-direction';

export class ForwardOnlySearchCriteria {
  limit: number;
  continuationToken: string;
  sortByFieldName: string;
  sortDirection: SortOrder;
  batchId?: string;
}
